module.exports = __webpack_public_path__ + "static/media/defaultSubject.c8b9ad2b.svg";